import { ApplicationConfig, APP_INITIALIZER, LOCALE_ID, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import { TranslateModule, MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor';
import { LocaleService } from './core/locale.service';

// Register locale data for French and Spanish
registerLocaleData(localeFr);
registerLocaleData(localeEs);

export class AppMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    if (isDevMode()) {
      console.warn(`Missing translation key: "${params.key}" for locale: "${params.translateService.currentLang || params.translateService.defaultLang}"`);
    }
    return params.key;
  }
}

export function initializeLocale(localeService: LocaleService): () => void {
  return () => localeService.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: AppMissingTranslationHandler,
        },
        defaultLanguage: 'en',
        useDefaultLang: true,
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeLocale,
      deps: [LocaleService],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useFactory: (localeService: LocaleService) => localeService.localeSignal(),
      deps: [LocaleService],
    },
  ]
};
